import { useEffect, useRef } from 'react';
import { usePaintVersion } from '../lib/prefs';
import { dpr, readTokens } from './canvasTokens';

/* mostrador pequeno — mesma linguagem do instrumento do Início */
export function SmallDial({ value, seg = 1, size, label, caption }: {
  value: number; seg?: number; size: number; label: string | number; caption: string;
}) {
  const cv = useRef<HTMLCanvasElement>(null);
  const paint = usePaintVersion();

  useEffect(() => {
    const draw = () => {
      const canvas = cv.current;
      if (!canvas) return;
      const C = readTokens();
      const d = dpr(), S = size, val = Math.max(0, Math.min(1, value / 100)), segs = Math.max(1, seg);
      if (canvas.width !== S * d) { canvas.width = S * d; canvas.height = S * d; }
      const g = canvas.getContext('2d')!;
      g.setTransform(d, 0, 0, d, 0, 0); g.clearRect(0, 0, S, S);
      const c = S / 2, R = S / 2 - 13, TAU = Math.PI * 2, GAP = segs > 1 ? .08 : 0;
      for (let i = 0; i < 24; i++) {
        const a = -Math.PI / 2 + i / 24 * TAU, r1 = S / 2 - 2, r2 = r1 - (i % 6 === 0 ? 5 : 2.5);
        g.beginPath(); g.moveTo(c + Math.cos(a) * r1, c + Math.sin(a) * r1); g.lineTo(c + Math.cos(a) * r2, c + Math.sin(a) * r2);
        g.lineWidth = 1; g.strokeStyle = i % 6 === 0 ? C.strong : C.faint; g.stroke();
      }
      for (let i = 0; i < segs; i++) {
        const a0 = -Math.PI / 2 + i / segs * TAU + GAP / 2, a1 = -Math.PI / 2 + (i + 1) / segs * TAU - GAP / 2;
        g.beginPath(); g.arc(c, c, R, a0, a1); g.lineWidth = 3; g.lineCap = 'round'; g.strokeStyle = C.faint; g.stroke();
        const lo = i / segs, hi = (i + 1) / segs, f = Math.max(0, Math.min(1, (val - lo) / (hi - lo)));
        if (f > .004) { g.beginPath(); g.arc(c, c, R, a0, a0 + (a1 - a0) * f); g.lineWidth = 3; g.strokeStyle = C.brand; g.stroke(); }
      }
    };
    draw();
    document.fonts?.ready.then(draw).catch(() => {});
  }, [value, seg, size, paint]);

  return (
    <div className="dial-sm">
      <canvas ref={cv} width={size} height={size} style={{ width: size, height: size }} aria-hidden="true" />
      <div className="rd"><b>{label}</b><span>{caption}</span></div>
    </div>
  );
}
